/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NazioneDTO
 */
export interface NazioneDTO {
    /**
     * 
     * @type {string}
     * @memberof NazioneDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof NazioneDTO
     */
    descrizione?: string;
}

/**
 * Check if a given object implements the NazioneDTO interface.
 */
export function instanceOfNazioneDTO(value: object): value is NazioneDTO {
    return true;
}

export function NazioneDTOFromJSON(json: any): NazioneDTO {
    return NazioneDTOFromJSONTyped(json, false);
}

export function NazioneDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): NazioneDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'descrizione': json['descrizione'] == null ? undefined : json['descrizione'],
    };
}

export function NazioneDTOToJSON(value?: NazioneDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'descrizione': value['descrizione'],
    };
}

